import { CheckCircle, XCircle, Gift, Loader2 } from 'lucide-react';
import { useOAuth2Callback } from '../hooks/useOAuth2Callback';
var OAuth2CallbackPage = function(param) {
    var config = param.config, tmp = param.appIcon, AppIcon = tmp === void 0 ? Gift : tmp, _param_successMessage = param.successMessage, successMessage = _param_successMessage === void 0 ? '로그인이 완료되었습니다!' : _param_successMessage, loginPath = param.loginPath;
    var _config_routes;
    var _useOAuth2Callback = useOAuth2Callback(config), isLoading = _useOAuth2Callback.isLoading, errorMsg = _useOAuth2Callback.errorMsg, navigate = _useOAuth2Callback.navigate;
    var _ref;
    var resolvedLoginPath = (_ref = loginPath !== null && loginPath !== void 0 ? loginPath : (_config_routes = config.routes) === null || _config_routes === void 0 ? void 0 : _config_routes.loginPath) !== null && _ref !== void 0 ? _ref : '/login';
    var getStatusIcon = function() {
        if (isLoading) {
            return /*#__PURE__*/ React.createElement(Loader2, {
                className: "w-12 h-12 text-blue-600 animate-spin"
            });
        } else if (errorMsg) {
            return /*#__PURE__*/ React.createElement(XCircle, {
                className: "w-16 h-16 text-red-500"
            });
        } else {
            return /*#__PURE__*/ React.createElement(CheckCircle, {
                className: "w-16 h-16 text-green-500"
            });
        }
    };
    var getStatusColor = function() {
        if (isLoading) {
            return 'text-blue-600';
        } else if (errorMsg) {
            return 'text-red-600';
        } else {
            return 'text-green-600';
        }
    };
    var getStatusMessage = function() {
        if (isLoading) {
            return '로그인 처리 중...';
        } else if (errorMsg) {
            return errorMsg;
        } else {
            return successMessage;
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center px-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "p-8 text-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-16 h-16 rounded-xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center mx-auto mb-6"
    }, /*#__PURE__*/ React.createElement(AppIcon, {
        className: "w-8 h-8 text-white"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center items-center mb-6 min-h-[64px]"
    }, getStatusIcon()), /*#__PURE__*/ React.createElement("h2", {
        className: "text-xl font-semibold mb-4 ".concat(getStatusColor())
    }, getStatusMessage()), isLoading && /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-500 text-sm"
    }, "잠시만 기다려주세요..."), !isLoading && !errorMsg && /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-500 text-sm"
    }, "앱으로 이동합니다."), errorMsg && /*#__PURE__*/ React.createElement("div", {
        className: "space-y-2 mt-4"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-500 text-sm"
    }, "로그인 페이지로 돌아갑니다."), /*#__PURE__*/ React.createElement("button", {
        onClick: function() {
            return navigate(resolvedLoginPath, {
                replace: true
            });
        },
        className: "text-blue-600 hover:text-blue-700 text-sm font-medium underline px-4 py-2 border border-blue-200 rounded hover:bg-blue-50 transition-colors",
        type: "button"
    }, "지금 돌아가기")))));
};
export default OAuth2CallbackPage;
